

// import { getHistory } from './history.js';


import { cachedClient } from './client.js';

import { getHistory } from './resources/history.js';

import { fetchRequest } from './resources/request.js';

import { doClaim } from './resources/claim.js';

import { doClose, doQuestion, doRecall } from './resources/response.js';

import { load, loadMentor, loadUnclaimed, loadCalls, loadLive, loadClaimed, dismiss } from './resources/queue.js';

function cacheSet(key, value) {
	localStorage.setItem(key, value);
}

function cacheGet(key) {
	return localStorage.getItem(key);
}

function cacheDelete(key) {
	return localStorage.removeItem(key);
}


const API = {
	// above...
	cache: {
		get: cacheGet,
		set: cacheSet,
		delete: cacheDelete
	},
	
	// history.js
	getHistory: (data) => cachedClient(data, getHistory),

	// request.js
	fetchRequest: (data) => cachedClient(data, fetchRequest),
// 	fetchUnclaimed: (data) => cachedClient(data, fetchUnclaimed),

	// claim.js
	doClaim: (data) => cachedClient(data, doClaim),

	// response.js
	doClose: (data) => cachedClient(data, doClose),
	doQuestion: (data) => cachedClient(data, doQuestion),
	doRecall: (data) => cachedClient(data, doRecall),		

	// queue.js
	queue: {
		load: (data) => cachedClient(data, load),
		loadMentor: (data) => cachedClient(data, loadMentor),
		loadUnclaimed: (data) => cachedClient(data, loadUnclaimed),
		loadClaimed: (data) => cachedClient(data, loadClaimed),
		loadCalls: (data) => cachedClient(data, loadCalls),
		loadLive: (data) => cachedClient(data, loadLive),

		dismiss: (data) => cachedClient(data, dismiss),
	}
};

export default API;
